export const _en = {
    addButton: {
        label: "Add a avaibility"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add an avaibility",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Plage de planification"
    },
    toggleDeleted: {
        label: "Afficher les élements archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'une plage de planification",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    }
};